import React from 'react';
import { motion } from 'framer-motion';
import { Check, Flame, ThermometerSun, Snowflake, Wind, Wrench } from 'lucide-react';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function Ancillaries() {
  const features = ['Hoses & fittings', 'Heat exchangers', 'Fuel tanks', 'Generators', 'Pumps', 'Ducting & distribution'];
  const relatedServices = [{
    title: 'Boiler Hire',
    icon: Flame,
    path: '/boiler-hire'
  }, {
    title: 'Heater Hire',
    icon: ThermometerSun,
    path: '/heater-hire'
  }, {
    title: 'Chiller Hire',
    icon: Snowflake,
    path: '/chiller-hire'
  }, {
    title: 'Cooling Hire',
    icon: Wind,
    path: '/cooling-hire'
  }];
  return <main className="flex-grow" data-id="element-243">
      <ServicePageHero title="Ancillaries" subtitle="Everything needed to complete your temporary HVAC installation safely and efficiently." bgImage="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-van-next-to-packaged-boiler.webp" data-id="element-244" />

      <section className="py-20 bg-white" data-id="element-245">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-247">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2" data-id="element-248">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark mb-6" data-id="element-249">
                Complete Turnkey Support
              </h2>

              <div className="space-y-4 text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-250">
                <p data-id="element-251">
                  A successful temporary heating or cooling project requires
                  more than just the primary plant. We provide a comprehensive
                  range of high-quality ancillary equipment to ensure your
                  installation is safe, efficient, and fully integrated with
                  your existing systems.
                </p>
                <p data-id="element-252">
                  Our inventory includes FDA-approved hoses, heavy-duty ducting,
                  plate heat exchangers, calorifiers, and specialized pumps. We
                  also supply robust fuel tanks and temporary power generators
                  to support standalone operations where site utilities are
                  unavailable or insufficient.
                </p>
                <p data-id="element-253">
                  By sourcing all components from a single provider, you benefit
                  from guaranteed compatibility and streamlined project
                  management. Our engineers specify the exact ancillaries
                  required during the initial site survey, ensuring a seamless
                  installation process.
                </p>
                <p data-id="element-254">
                  All our ancillary equipment is rigorously tested and
                  maintained to the highest industry standards, providing the
                  reliability you need for critical applications.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-255">
                {features.map((feature, i) => <div key={i} className="flex items-start" data-id="element-256">
                    <div className="bg-brand-green/20 p-1 rounded-full mr-3 mt-1 flex-shrink-0" data-id="element-257">
                      <Check className="w-4 h-4 text-brand-dark" data-id="element-258" />
                    </div>
                    <span className="text-sm font-medium text-brand-dark" data-id="element-259">
                      {feature}
                    </span>
                  </div>)}
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2 sticky top-24" data-id="element-260">
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-van-next-to-packaged-boiler.webp" alt="Rapid Energy Equipment Setup" className="rounded-2xl shadow-2xl w-full object-cover h-[500px]" data-id="element-261" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-16 bg-brand-light" data-id="element-262">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-263">
          <h3 className="text-2xl font-heading font-bold text-brand-dark mb-8 text-center" data-id="element-264">
            Related Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-265">
            {relatedServices.map((service, index) => <Link key={index} to={service.path} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group flex flex-col items-center text-center" data-id="element-266">
                <div className="w-12 h-12 bg-brand-light rounded-lg flex items-center justify-center mb-4 group-hover:bg-brand-green/20 transition-colors" data-id="element-267">
                  <service.icon className="w-6 h-6 text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-268" />
                </div>
                <h4 className="font-heading font-bold text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-269">
                  {service.title}
                </h4>
              </Link>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-270" />
    </main>;
}